import React, { useState } from 'react';
import { XIcon, PlusIcon, TrashIcon } from 'lucide-react';
const BatchTicketEntryModal = ({
  onClose,
  groupId
}) => {
  const [tickets, setTickets] = useState([{
    id: 1,
    startTicketNo: '',
    endTicketNo: '',
    quantity: '',
    stockType: 'NT',
    conjTicket: '',
    airlineCode: '',
    class: '',
    paxName: '',
    sector: '',
    sectorDesc: '',
    tax: '',
    airFare: '',
    remark: ''
  }]);
  const addTicket = () => {
    setTickets([...tickets, {
      id: tickets.length + 1,
      startTicketNo: '',
      endTicketNo: '',
      quantity: '',
      stockType: 'NT',
      conjTicket: '',
      airlineCode: '',
      class: '',
      paxName: '',
      sector: '',
      sectorDesc: '',
      tax: '',
      airFare: '',
      remark: ''
    }]);
  };
  const removeTicket = id => {
    if (tickets.length === 1) return;
    setTickets(tickets.filter(ticket => ticket.id !== id));
  };
  const handleChange = (id, field, value) => {
    setTickets(tickets.map(ticket => ticket.id === id ? {
      ...ticket,
      [field]: value
    } : ticket));
  };
  const handleSubmit = e => {
    e.preventDefault();
    console.log('Submitting batch tickets:', tickets);
    onClose();
  };
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center" data-id="element-138">
      <div className="relative bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-y-auto" data-id="element-139">
        <div className="flex items-start justify-between p-4 border-b border-gray-200" data-id="element-140">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-141">
            Batch Ticket Entry - Group {groupId}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-142">
            <XIcon className="h-6 w-6" data-id="element-143" />
          </button>
        </div>
        <form onSubmit={handleSubmit} data-id="element-144">
          <div className="p-6" data-id="element-145">
            <div className="overflow-x-auto" data-id="element-146">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-147">
                <thead className="bg-gray-50" data-id="element-148">
                  <tr data-id="element-149">
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-150">
                      Start Tkt No
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-151">
                      End No
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-152">
                      Qty
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-153">
                      StockType
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-154">
                      Conj Tkt
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-155">
                      A/L Code
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-156">
                      Class
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-157">
                      Pax Name
                    </th>
                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-158">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-159">
                  {tickets.map((ticket, index) => <tr key={ticket.id} data-id="element-160">
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-161">
                        <input type="text" value={ticket.startTicketNo} onChange={e => handleChange(ticket.id, 'startTicketNo', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. 0002640609080" data-id="element-162" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-163">
                        <input type="text" value={ticket.endTicketNo} onChange={e => handleChange(ticket.id, 'endTicketNo', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. 0002640609099" data-id="element-164" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-165">
                        <input type="text" value={ticket.quantity} onChange={e => handleChange(ticket.id, 'quantity', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. 20" data-id="element-166" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-167">
                        <select value={ticket.stockType} onChange={e => handleChange(ticket.id, 'stockType', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" data-id="element-168">
                          <option value="NT" data-id="element-169">NT</option>
                          <option value="ET" data-id="element-170">ET</option>
                        </select>
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-171">
                        <input type="text" value={ticket.conjTicket} onChange={e => handleChange(ticket.id, 'conjTicket', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" data-id="element-172" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-173">
                        <input type="text" value={ticket.airlineCode} onChange={e => handleChange(ticket.id, 'airlineCode', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. QR" data-id="element-174" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-175">
                        <input type="text" value={ticket.class} onChange={e => handleChange(ticket.id, 'class', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. G" data-id="element-176" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap" data-id="element-177">
                        <input type="text" value={ticket.paxName} onChange={e => handleChange(ticket.id, 'paxName', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm" placeholder="e.g. LOH/POHLEE MS" data-id="element-178" />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap text-right" data-id="element-179">
                        <button type="button" onClick={() => removeTicket(ticket.id)} className="text-red-600 hover:text-red-900" data-id="element-180">
                          <TrashIcon className="h-5 w-5" data-id="element-181" />
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="mt-4" data-id="element-182">
              <button type="button" onClick={addTicket} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-183">
                <PlusIcon className="h-5 w-5 mr-1" data-id="element-184" />
                Add Another Ticket
              </button>
            </div>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-185">
              <div data-id="element-186">
                <label className="block text-sm font-medium text-gray-700" data-id="element-187">
                  Sector Code
                </label>
                <input type="text" value={tickets[0].sector} onChange={e => handleChange(tickets[0].id, 'sector', e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. SINCAI" data-id="element-188" />
              </div>
              <div data-id="element-189">
                <label className="block text-sm font-medium text-gray-700" data-id="element-190">
                  Sector Description
                </label>
                <input type="text" value={tickets[0].sectorDesc} onChange={e => handleChange(tickets[0].id, 'sectorDesc', e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. SIN/CAI/SIN" data-id="element-191" />
              </div>
              <div data-id="element-192">
                <label className="block text-sm font-medium text-gray-700" data-id="element-193">
                  Issue Date
                </label>
                <input type="date" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-194" />
              </div>
              <div data-id="element-195">
                <label className="block text-sm font-medium text-gray-700" data-id="element-196">
                  Other Bkg Ref
                </label>
                <input type="text" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. QGDCIP" data-id="element-197" />
              </div>
              <div data-id="element-198">
                <label className="block text-sm font-medium text-gray-700" data-id="element-199">
                  Ticket Tax
                </label>
                <input type="text" value={tickets[0].tax} onChange={e => handleChange(tickets[0].id, 'tax', e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. 469.10" data-id="element-200" />
              </div>
              <div data-id="element-201">
                <label className="block text-sm font-medium text-gray-700" data-id="element-202">
                  Unit Ticket Cost
                </label>
                <input type="text" value={tickets[0].airFare} onChange={e => handleChange(tickets[0].id, 'airFare', e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. 1,224.00" data-id="element-203" />
              </div>
              <div className="md:col-span-2" data-id="element-204">
                <label className="block text-sm font-medium text-gray-700" data-id="element-205">
                  Remark
                </label>
                <textarea value={tickets[0].remark} onChange={e => handleChange(tickets[0].id, 'remark', e.target.value)} rows={2} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. set 'UATP' in first 4 chars for UATP TK." data-id="element-206" />
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200" data-id="element-207">
            <button type="submit" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-208">
              Save Tickets
            </button>
            <button type="button" onClick={onClose} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-209">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default BatchTicketEntryModal;